import { useDispatch, useSelector } from "react-redux";
import { GetComponentRoundByFlowAndActionGUID } from "../../Redux/Reducers/Manager/FlowComponent";
import { WorkFlowStep } from "../../Redux/Reducers/Manager/WorkFlowStep";
import "./style.css";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { use } from "react";
import ApplicationInformationConfirmation from "../../Pages/Manager/ApplicationInformationConfirmation";
import ButtonAHSF from "../../Components/ButtonAHSF";
import { GetSpecificRowAction } from "../../Redux/Reducers/Manager/Action";
import TableEvaluators from "../../Pages/Manager/TableEvaluators";
import ActionOnApplication from "../../Pages/Manager/ActionOnApplication";
import SharedDiv from "../../Components/SharedDiv/SharedDiv";
import { SetArrayDataCheckBoks } from "../../Redux/Reducers/Shared/CheckBox";
import Swal from "sweetalert2";

const ContainerTasks = () => {
  const [ActionReason, setActionReason] = useState(null);
  const WorkFlowResult = useSelector((state) => state.StepsWorkFlow.workFlow);
  const WorkFlowResultStatus = useSelector((state) => state.StepsWorkFlow.loadingWorkFlow);

  const [RecommendationId, setRecommendationId] = useState(null);
  const [Attachment, setAttachment] = useState(null);

  const [AdditionalNotes, setAdditionalNotes] = useState(false);

  const ComponentRoundByFlow = useSelector((state) =>
    state.FlowComponent.FlowComponent?.map((item) => item.componentId)
  );

  const ActionsName = useSelector((state) => state.ActionReducer.ActionRow);

  // const ComponentRoundByFlow = useSelector((state) => state.FlowComponent.FlowComponent);
  const [ComponentRoundByFlowList, setComponentRoundByFlowList] = useState([]);
  const arrayDataCheckBoks = useSelector(
    (state) => state.arrayDataCheckBoks.arrayDataCheckBoks
  );

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { actionGuid, flowGUID, RoundId, FieldId } = useParams();
  const addWorkFlowStep = async () => {
    const missingFields = [];

    if (
      !ActionReason &&
      (ComponentRoundByFlow?.includes("c5f49e37-997b-4bef-a8df-571791dc6d6a") )
    )
      missingFields.push("السبب");
    if (
      !Attachment &&
      (
        ComponentRoundByFlow?.includes(
          "4f90a961-372a-4973-8043-65fb7c3e2d58"
        ) )
    )
      missingFields.push("المرفق");

    // if (
    //   (!arrayDataCheckBoks["evaluatorList"] ||
    //     arrayDataCheckBoks["evaluatorList"].length === 0) &&
    //   ComponentRoundByFlow?.includes("8bf80815-add3-468a-b026-2158b80defbf")
    // )
    //   missingFields.push("الرجاء اختيار مقيم واحد على الاقل");

    if (actionGuid === "119a7606-07c4-414c-bf84-e15c857e40cc") {
      if (arrayDataCheckBoks["evaluatorList"]?.length != 2) {
        missingFields.push("يجب اختيار مقيمين اثنين فقط");
      }
    }

    if (actionGuid === "de391e63-534c-45f2-98e6-43e2d3520976") {
      if (arrayDataCheckBoks["evaluatorList"]?.length != 1) {
        missingFields.push("يجب اختيار مقيم واحد فقط ");
      }
    }

    if (missingFields.length > 0) {
      Swal.fire({
        icon: "warning",
        title: "الرجاء تعبئة الحقول التالية",
        html: `
          <div style="text-align: right; direction: rtl; font-size: 16px;">
            <ul style="list-style-type: none; padding: 0;">
              ${missingFields
                .map(
                  (field) =>
                    `<li style="margin-bottom: 8px;">🔸 <strong>${field}</strong></li>`
                )
                .join("")}
            </ul>
          </div>
        `,
        confirmButtonText: "حسناً",
        customClass: {
          popup: "swal2-border-radius",
        },
      });
      return;
    }

    const formData = new FormData();
    formData.append("ActionId", actionGuid);
    formData.append("FlowId", flowGUID);
    formData.append("ApplicationInformationId", null);
    formData.append("RecommendationId", RecommendationId);
    formData.append("ActionReason", ActionReason);
    formData.append(
      "tasksIdsList",
      JSON.stringify(arrayDataCheckBoks?.tasksList.map((item) => item.taskId))
    );
    formData.append(
      "UsersList",
      JSON.stringify(
        arrayDataCheckBoks["evaluatorList"]?.map((item) => item.userId)
      )
    );
    formData.append("file", Attachment); // ملف من input[type="file"]
    const response = await dispatch(WorkFlowStep(formData))
    if (response.payload.result?.length > 0) {
      Swal.fire({
        icon: "warning",
        title: "الرجاء تعبئة الحقول التالية",
        html: `
          <div style="text-align: right; direction: rtl; font-size: 16px;">
            <ul style="list-style-type: none; padding: 0;">
              ${response.payload.result.map(
                  (ele) =>
                    `<li style="margin-bottom: 8px;">🔸 <strong>${ele.message}</strong></li>`
                )
                .join("")}
            </ul>
          </div>
        `,
        confirmButtonText: "حسناً",
        customClass: {
          popup: "swal2-border-radius",
        },
      });
      return;
    } else {
      localStorage.removeItem("persist:root");
      dispatch(SetArrayDataCheckBoks());
      navigate("/SRFund/manager/TransferRequestsStatus/");
    }

    if (response.payload) {
      // Handle success
      console.log(response.payload, "res");
    } else {
      // Handle error
    }
  };

  

  useEffect(() => {
    dispatch(
      GetComponentRoundByFlowAndActionGUID({
        actionGuid: actionGuid,
        flowGUID: flowGUID,
      })
    );
    dispatch(
      GetSpecificRowAction({
        actionId: actionGuid,
      })
    );
  }, [actionGuid, flowGUID]);
console.log(ComponentRoundByFlow,"ComponentRoundByFlow");

  return (
    <>
      {ComponentRoundByFlow?.includes(
        "ff947cd6-dfae-48f7-92dc-8a977894a073"
      ) ? (
        <ApplicationInformationConfirmation flow={flowGUID} />
      ) : (
        <></>
      )}

      {ComponentRoundByFlow?.includes(
        "8bf80815-add3-468a-b026-2158b80defbf"
      ) ? (
        <>
          <TableEvaluators FieldId={FieldId} RoundId={RoundId} />
        </>
      ) : (
        <></>
      )}
      {ComponentRoundByFlow?.includes("c5f49e37-997b-4bef-a8df-571791dc6d6a") ||
      ComponentRoundByFlow?.includes("4f90a961-372a-4973-8043-65fb7c3e2d58") ||
      ComponentRoundByFlow?.includes("0bed9655-e693-4493-bc43-1363b9f99304") ||
      ComponentRoundByFlow?.includes("364d0cb4-1e77-4f7b-9bf6-c5c77e74fd2d") ? (
        <>
          <SharedDiv
            showTitle={true}
            titleName="الإجراءات على الطلب"
            child={[
              <>
                <ActionOnApplication
                  Recommendation={ComponentRoundByFlow?.includes(
                    "364d0cb4-1e77-4f7b-9bf6-c5c77e74fd2d"
                  )}
                  setAttachment={setAttachment}
                  Attachment={ComponentRoundByFlow?.includes(
                    "4f90a961-372a-4973-8043-65fb7c3e2d58"
                  )}
                  Reason={ComponentRoundByFlow?.includes(
                    "c5f49e37-997b-4bef-a8df-571791dc6d6a"
                  )}
                  AdditionalNotes={ComponentRoundByFlow?.includes(
                    "0bed9655-e693-4493-bc43-1363b9f99304"
                  )}
                  
                  actionGuid={actionGuid}
                  setActionReason={setActionReason}
                  setRecommendationId={setRecommendationId}
                  setAdditionalNotes={setAdditionalNotes}
                  FieldId={FieldId}
                  RoundId={RoundId}
                  ContainerTasks={true}
                />
              </>,
            ]}
          />
        </>
      ) : (
        <></>
      )}
      <div className="containersButton">
        <div>
          <ButtonAHSF
            style={{ width: "256px" }}
            type={"submitter"}
            onClick={addWorkFlowStep}
            disabled={false}
            // title={Object.keys(props).length == 0 ? "إضافة" : "تعديل"}
            text={ActionsName?.actionName}
            show={true}
          />
        </div>
      </div>
    </>
  );
};

export default ContainerTasks;
